<template>
    <v-container class="container" fluid>
        <v-card>
            <v-system-bar height="70px" dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">Driver Form
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-system-bar>

            <v-tabs centered>
                <v-tab>Personal Information</v-tab>
                <v-tab>Financial Information</v-tab>
                <v-tab>Certification and Licensing</v-tab>
                <v-tab>Safety Compliance</v-tab>
                <v-tab>Dispatch fields</v-tab>

                <v-tab-item>
                    <v-form ref="form" lazy-validation>
                        <v-container>
                            <v-row class="mx-5" justify="center">
                                <v-col cols="8">
                                    <v-text-field label="Driver Name" v-model="editedItem.Name" required :rules="[
                                        v => !!v || 'Name is required'
                                    ]"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-5" justify="center">
                                <v-col cols="8">
                                    <v-text-field label="Address" v-model="editedItem.Address" :rules="[
                                        v => !!v || 'Address is required'
                                    ]"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-5" justify="center">
                                <v-col cols="4">
                                    <v-text-field label="City" v-model="editedItem.City" :rules="[
                                        v => !!v || 'City is required'
                                    ]"></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field label="Province" v-model="editedItem.Province" :rules="[
                                        v => !!v || 'Province is required'
                                    ]"></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field label="Postal Code" v-model="editedItem.PostalCode"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-5" justify="center">
                                <v-col cols="2">
                                    <v-text-field label="Main Phone" v-model="editedItem.Phone1" :rules="[
                                        v => !!v || 'Main Phone is required'
                                    ]"></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field label="Secondary Phone" v-model="editedItem.Phone2"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field label="Email Address" v-model="editedItem.Email"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-5" justify="center">
                                <v-col cols="4">
                                    <v-text-field label="Social Insurance Number" v-model="editedItem.SIN">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'" label="Birth Date"
                                        v-model="editedItem.BirthDate"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-5" justify="center">
                                <v-col cols="5">
                                    <v-text-field label="Emergency Contact Name"
                                        v-model="editedItem.EmergencyContact"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Emergency Contact Phone"
                                        v-model="editedItem.EmergencyContactNo"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-tab-item>

                <v-tab-item>
                    <v-container>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="4">
                                <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'" label="Employee Start Date"
                                    v-model="editedItem.StartDate"></v-text-field>
                            </v-col>

                            <v-col cols="4">
                                <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'" label="Employee End Date"
                                    v-model="editedItem.TerminationDate"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'" label="Benefits Start Date"
                                    v-model="editedItem.BenefitStartDate"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-combobox v-model="type" :items="types" label="Driver Type" :item-text="'DriverType'"
                                    :item-value="'DriverTypeId'" @change="selectType" auto-select-first></v-combobox>
                            </v-col>
                            <v-col cols="2">
                                <v-combobox v-model="region" :items="regions" label="Work Region"
                                    :item-text="'PrincipalRegion'" :item-value="'PrincipalRegionID'"
                                    @change="selectWorkRegion" auto-select-first></v-combobox>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="1">
                                <v-text-field prepend-inner-icon="mdi-currency-usd" label="Rate Amount"
                                    v-model="editedItem.Rate"></v-text-field>
                            </v-col>
			    
                            <v-col cols="1">
                                <v-text-field
                                    prepend-inner-icon="mdi-currency-usd"
                                    label="Rate Amount PM"
                                    v-model="editedItem.RatePM"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="1">
                                <v-checkbox label="HST" v-model="editedItem.HST">
                                </v-checkbox>
                            </v-col>
                            <v-col cols="1">
                                <v-checkbox label="ElaPay" v-model="editedItem.ElaPay">
                                </v-checkbox>
                            </v-col>

                            <v-col cols="1">
                                <v-combobox v-model="editedItem.ShiftDrv" :items="ShiftDrv"
                                    label="Shift Type"></v-combobox>
                            </v-col>
                            <v-col cols="1">
                                <v-spacer />
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field label="Fixed Rate Factor"
                                    v-model="editedItem.FixedRateFactor"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="Variable Rate Factor"
                                    v-model="editedItem.VariableRateFactor"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field label="Fixed Split Rate"
                                    v-model="editedItem.FixedSplitRate"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="Variable Split Rate"
                                    v-model="editedItem.VariableSplitRate"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>

                <v-tab-item>
                    <v-row class="mx-5" justify="center">
                        <v-col cols="4">
                            <v-text-field label="Driver License Number" v-model="editedItem.DLNumber"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'"
                                label="Drivers License Expiry Date" v-model="editedItem.DLExpiry"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5" justify="center">
                        <v-col cols="4">
                            <v-text-field label="CPPI Certification Number"
                                v-model="editedItem.CPPICertification"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'"
                                label="CPPI Certification Expiry Date"
                                v-model="editedItem.CPPICertificationExp"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5" justify="center">
                        <v-col cols="4">
                            <v-text-field label="TDG  Certification Number"
                                v-model="editedItem.TDGBadgeNum"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'"
                                label="TDG Certification Expiry Date" v-model="editedItem.TDGBadgeExp"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5" justify="center">
                        <v-col cols="4">
                            <v-text-field label="WHMIS Certification Number"
                                v-model="editedItem.WhimisBadgeNum"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'"
                                label="WHMIS Certification Expiry Date"
                                v-model="editedItem.WhimisBadgeExp"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5" justify="center">
                        <v-col cols="4">
                            <div style="display: flex;flex: 1;align-items: center;justify-content:space-between;">
                                <v-switch label="Jet Certification" v-model="editedItem.JetCertification"></v-switch>
                                <v-switch label="ASR Trained" v-model="editedItem.EleosApp"></v-switch>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'"
                                label="Fire Spill Training Date"
                                v-model="editedItem.FireSpillTrainingDate"></v-text-field>
                        </v-col>
                    </v-row>
                </v-tab-item>

                <v-tab-item>
                    <v-row class="mx-5" justify="center">
                        <v-col cols="4">
                            <v-combobox v-model="company" :items="companys" label="Company" :item-text="'Company'"
                                :item-value="'CompanyId'" @change="selectCompany" auto-select-first></v-combobox>
                        </v-col>
                        <v-col cols="4">
                            <div>

                                <v-combobox v-model="frequency" :items="frequencies" label="Frequency"
                                    :item-text="'Frequency'" :item-value="'FrequencyId'" @change="selectFrenquecy"
                                    auto-select-first class="float-left" style="width: 80%;"></v-combobox>
                                <v-icon :color="frequencyColor" class="float-left mt-5">mdi-circle</v-icon>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5" justify="center">
                        <v-col cols="4">
                            <v-text-field label="Amount" v-model="editedItem.SafetyAmount"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field label="Safety Bonus" v-model="editedItem.SafetyBonus"></v-text-field>
                        </v-col>
                    </v-row>
                </v-tab-item>
                <v-tab-item>
                    <v-row class="mx-5" justify="center">
                        <v-col cols="3">
                            <v-combobox v-model="rgDispatch" :items="regions" label="Dispatch Region"
                                :item-text="'PrincipalRegion'" :item-value="'PrincipalRegionID'"
                                @change="selectRegionDispatch" auto-select-first></v-combobox>
                        </v-col>
                        <v-col cols="3">
                            <v-combobox v-model="truck" :items="trucks" label="Truck Default"
                                :item-text="'Truck'" :item-value="'TruckID'"
                                @change="selectTruckDefault" auto-select-first></v-combobox>
                        </v-col>
                    </v-row>
                </v-tab-item>
            </v-tabs>
            <v-row justify="end">
                <v-col cols="12">
                    <v-btn exact dark color="secondary" class="mr-10 white--text" :to="'/catalogs/drivers'"
                        style="float:right;">
                        Close
                        <v-icon right dark>mdi-close</v-icon>
                    </v-btn>
                    <v-btn dark color="secondary" class="mx-5 white--text" @click="validate()" style="float:right;">
                        Save
                        <v-icon right dark>mdi-content-save</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mask } from 'vue-the-mask';
export default {
    directives: {
        mask
    },
    data() {
        return {
            valid: false,
            driverID: 0,
            type: null,
            types: null,
            frequencies:null,
            frequency:null,
            defaultItem: {
                Name: null,
                Address: null,
                City: null,
                Province: null,
                PostalCode: null,
                Phone1: null,
                Phone2: null,
                Email: null,
                SIN: null,
                BirthDate: null,
                EmergencyContact: null,
                EmergencyContactNo: null,
                StartDate: null,
                TerminationDate: null,
                BenefitStartDate: null,
                Rate: null,
                FixedRateFactor: null,
                VariableRateFactor: null,
                FixedSplitRate: null,
                VariableSplitRate: null,
                HST: null,
                ElaPay: null,
                DLNumber: null,
                DLExpiry: null,
                CPPICertification: null,
                CPPICertificationExp: null,
                TDGBadgeNum: null,
                TDGBadgeExp: null,
                WhimisBadgeNum: null,
                WhimisBadgeExp: null,
                FireSpillTrainingDate: null,
                JetCertification: null,
                EleosApp: null,
            },
            editedItem: {
                DriverType: null,
                Name: null,
                Address: null,
                City: null,
                Province: null,
                PostalCode: null,
                Phone1: null,
                Phone2: null,
                Email: null,
                SIN: null,
                BirthDate: null,
                EmergencyContact: null,
                EmergencyContactNo: null,
                StartDate: null,
                TerminationDate: null,
                BenefitStartDate: null,
                Rate: null,
                FixedRateFactor: null,
                VariableRateFactor: null,
                FixedSplitRate: null,
                VariableSplitRate: null,
                HST: null,
                ElaPay: null,
                DLNumber: null,
                DLExpiry: null,
                CPPICertification: null,
                CPPICertificationExp: null,
                TDGBadgeNum: null,
                TDGBadgeExp: null,
                WhimisBadgeNum: null,
                WhimisBadgeExp: null,
                FireSpillTrainingDate: null,
                JetCertification: null,
                Company: null,
                EleosApp: null,
                SafetyBonus: null,
                SafetyAmount: null,
                Frequency: null,
                WorkRegion: null,
                DispatchRegion: null,
		RatePM: null,
            },

            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
            ],
            regions: [],
            region: [],
            rgDispatch: [],
            trucks:[],
            truck:[],
            frequencyColor: null,
            companys: [],
            company: null,
            menuStartDate: false,
            menuEndDate: false,
            menuBenefits: false,
            menuBirthDate: false,
            menuDriversLicense: false,
            menuCPPI: false,
            menuTDG: false,
            menuWHMIS: false,
            menuFireSpill: false,
            ShiftDrv: ['AM', 'PM'],
            dateRules: [
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ]
        };
    },
    async mounted()  {
       await this.loadTrucks();
        this.loadRegions();
        this.LoadFrequency();
        this.LoadCompanys();
        this.loadDrivers();
    },
    methods: {
        loadTrucks: function () {
            axios
                .get('truck/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.trucks = response.data;
                    console.log(this.trucks);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadRegions: function () {
            this.$store.state.isLoading = true;
            axios
                .get('regions', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.regions = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        LoadCompanys: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('truck/companys', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.companys = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        LoadFrequency: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('driver/frequency', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.frequencies = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        loadDrivers: function () {
            var str = this.$store;
            axios
                .get('driver-type', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.types = response.data;
                    console.log(this.types);

                    this.loadDriverData();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
        loadDriverData: function () {
            this.$store.state.isLoading = true;
            this.driverID = this.$store.state.editedDriver.id;
            var str = this.$store;
            if (this.driverID != 0) {
                axios
                    .get('driver/' + this.driverID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        this.editedItem = Object.assign({}, response.data);
                        this.$store.state.editedDriver.id = 0;
                        str.state.isLoading = false;
                        let brtDate = moment(this.editedItem.BirthDate).format('YYYY/MM/DD');
                        this.editedItem.BirthDate = brtDate;
                        const index = this.types.findIndex(elm => {
                            return (
                                elm.DriverTypeId == this.editedItem.DriverType
                            );
                        });
                        const idx = this.companys.findIndex(elm => {
                            return elm.CompanyId == this.editedItem.Company;
                        });
                        const idxFre = this.frequencies.findIndex(elm => {
                            return elm.FrequencyId == this.editedItem.Frequency;
                        });
                        const idxReg = this.regions.findIndex(elm => {
                            return elm.PrincipalRegionID == this.editedItem.WorkRegion;
                        });
                        const idxRegDisp = this.regions.findIndex(elm => {
                            return elm.PrincipalRegionID == this.editedItem.DispatchRegion;
                        });
                        const idxTruck = await this.trucks.findIndex(elm => {
                            return elm.TruckID == this.editedItem.TruckDefault;
                        });
                        console.log(idxTruck ,this.editedItem.TruckDefault);
                        this.truck = this.trucks[idxTruck];
                        this.rgDispatch = this.regions[idxRegDisp];
                        this.region = this.regions[idxReg];
                        this.frequency = this.frequencies[idxFre];
                        if (idxFre >= 0) {
                            this.frequencyColor = this.frequency.Color;
                        }
                        this.company = this.companys[idx];
                        this.type = this.types[index];
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        str.state.isLoading = false;
                    });
            } else {
                str.state.isLoading = false;
            }
        },
        selectType: function () {
            this.editedItem.DriverType = this.type.DriverTypeId;
            console.log(this.editedItem.DriverType);
        },
        selectRegionDispatch: function () {
            this.editedItem.DispatchRegion = this.rgDispatch.PrincipalRegionID;
            console.log(this.editedItem.DriverType);
        },
        
        selectTruckDefault: function () {
            this.editedItem.TruckDefault = this.truck.TruckID;
        },

        
        selectWorkRegion: function () {
            this.editedItem.WorkRegion = this.region.PrincipalRegionID;
            console.log(this.editedItem.DriverType);
        },
        selectCompany: function () {
            this.editedItem.Company = this.company.CompanyId;
        },
        selectFrenquecy: function () {
            this.editedItem.Frequency = this.frequency.FrequencyId;
            this.frequencyColor = this.frequency.Color;
        },
        newDriver: function () {
            console.log(this.editedItem);
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('driver', this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New driver added.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/drivers');
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        editDriver: function () {
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(this.editedItem);
            axios
                .put('driver/' + this.driverID, this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Driver information saved.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);

                    this.$store.state.isLoading = false;
                    this.$router.push('/catalogs/drivers');
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    this.$store.state.isLoading = false;
                });
        },
        save: function () {
            if (this.driverID > 0) {
                this.editDriver();
            } else {
                this.newDriver();
            }
        },

        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.save();
            }
        }
    }
};
</script>
